<template>
  <v-snackbar
    v-model="isSnackbarShown"
    timeout="10000"
    location="right"
    min-width="0"
    content-class="snackbar__wrapper"
  >
    <div v-if="snackbarConfig" class="snackbar__content">
      <e-icon
        :name="isInfo ? 'alert' : 'checkCircle'"
        :size="22"
        :class="{ 'text-blue': isInfo, 'text-green': isSuccess }"
        class="snackbar__icon"
      />
      <div>
        <b class="paragraph-m mr-2"> {{ snackbarConfig.title }} </b>
        <div v-if="snackbarConfig?.description" class="paragraph-s text-secondary mt-1">
          {{ snackbarConfig?.description }}
        </div>
      </div>
      <e-icon name="closeSvg" :size="18" class="snackbar__close" @click="close" />
    </div>
  </v-snackbar>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import { EIcon } from '@/core/components/ui';
import { useSnackbar } from '@/core/composables/useSnackbar';

const { isSnackbarShown, snackbarConfig } = useSnackbar();

const isInfo = toRef(() => snackbarConfig.value?.type === 'info');
const isSuccess = toRef(() => snackbarConfig.value?.type === 'success');

const close = () => {
  isSnackbarShown.value = false;
};
</script>

<style scoped lang="scss">
.snackbar {
  &__content {
    display: flex;

    color: $text-primary-color;
  }

  &__close {
    margin-left: $gap-3;

    color: $text-secondary-color;

    cursor: pointer;

    @include hover {
      color: $text-primary-color;
    }
  }

  &__icon {
    margin-right: 12px;

    color: $primary-color;
  }
}

:deep(.snackbar__wrapper) {
  margin: 0 12px;

  border: 1px solid $border-color-light;
  box-shadow: none;

  .v-snackbar__content {
    margin-right: 0;
    padding: 12px 11px 14px 14px;

    font-size: unset;
    line-height: unset;
    letter-spacing: unset;
  }
}
</style>
